<template>
  <GlobalDialog
    :titleCenter="false"
    dialogDefaultSize="70%"
    v-model="showDialog"
    title=""
    :showClose="false"
    :showActionButton="false"
    forceClose
  >
    <template #content>
      <div
        class="relative text-left overflow-hidden transform transition-all w-full"
      >
        <div
          class="flex items-start justify-between gap-4 pb-4 border-b border-untitled-gray-100"
        >
          <div class="flex items-start gap-3">
            <div
              class="flex items-center justify-center w-12 h-12 rounded-xl bg-app-primary/10 text-app-primary shrink-0"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                class="w-6 h-6"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
            </div>
            <div>
              <h3 class="text-base font-semibold text-untitled-gray-900">
                In Progress Courses
              </h3>
              <p class="text-sm text-untitled-gray-500 mt-0.5">
                Pick up right where you left off and keep your momentum going.
              </p>
            </div>
          </div>
          <button
            type="button"
            @click="showDialog = false"
            class="shrink-0 text-untitled-gray-400 hover:text-untitled-gray-600 transition-colors"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              class="w-6 h-6"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>

        <div
          class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 py-4 border-b border-untitled-gray-100"
        >
          <p class="text-sm text-untitled-gray-500">
            <span class="font-semibold text-untitled-gray-700">{{
              filteredCourseList.length
            }}</span>
            course<span v-if="filteredCourseList.length !== 1">s</span>
            in progress
          </p>
          <div class="flex items-center gap-2 w-full sm:w-auto">
            <label
              class="text-xs font-medium text-untitled-gray-500 whitespace-nowrap"
              >Sort by</label
            >
            <div class="w-full sm:w-[190px]">
              <ECombobox
                v-model="sortBy"
                name="sorts"
                :options="sorts"
                option-name="name"
                value-key="value"
                placeholder="Sort By"
                :multiple="false"
                :filterable="false"
                :clearable="false"
              />
            </div>
          </div>
        </div>
        <LoadingState v-if="loading" class="mx-auto text-center py-12" />
        <div class="" v-else>
          <ul
            v-if="filteredCourseList.length > 0"
            role="list"
            class="grid lg:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 md:grid-cols-1 grid-cols-1 gap-4 py-4 pr-1"
          >
            <li
              class="flex flex-col rounded-lg border border-untitled-gray-200 bg-white overflow-hidden hover:border-untitled-gray-300 hover:shadow-md transition-all"
              v-for="course in filteredCourseList"
              :key="course.id"
            >
              <div class="relative flex-shrink-0" v-if="course">
                <div
                  v-if="
                    course.thumbnail?.includes('iframe') ||
                    course.thumbnail?.includes('youtube')
                  "
                >
                  <div class="" v-html="course.thumbnail" />
                </div>
                <div
                  v-else
                  class="cursor-pointer"
                  @click="goToCourse(course.unit?.id)"
                >
                  <div class="relative">
                    <img
                      v-if="course.thumbnail"
                      :src="course.thumbnail"
                      class="w-full h-40 object-cover"
                    />
                    <img
                      v-else
                      src="https://lms-v2-staging.s3-us-west-2.amazonaws.com/modules/default-thumbnail.jpg"
                      class="w-full h-40 object-cover"
                    />

                    <div
                      class="absolute inset-0 flex items-center justify-center bg-black/0 hover:bg-black/30 transition-colors"
                    >
                      <div
                        class="flex items-center justify-center w-10 h-10 rounded-full bg-white/90 text-app-primary shadow-sm"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke-width="1.5"
                          stroke="currentColor"
                          class="w-5 h-5"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            d="M5.25 5.653c0-.856.917-1.398 1.667-.986l11.54 6.348a1.125 1.125 0 010 1.971l-11.54 6.347a1.125 1.125 0 01-1.667-.985V5.653z"
                          />
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="absolute top-2 right-2 inline-flex items-center gap-1 bg-app-secondary text-white text-[11px] font-semibold px-2 py-1 rounded-full shadow-sm"
                >
                  In Progress
                </div>
              </div>

              <div class="flex flex-col flex-1 p-4 gap-3">
                <h4
                  class="text-sm font-semibold text-untitled-gray-800 leading-snug"
                >
                  <a
                    href="#"
                    @click.prevent="goToCourse(course.unit?.id)"
                    class="hover:text-app-primary transition-colors"
                    >{{ course.name }}</a
                  >
                </h4>

                <div>
                  <div
                    class="flex items-center justify-between text-xs text-untitled-gray-500 mb-1"
                  >
                    <span>Progress</span>
                    <span class="font-medium text-untitled-gray-700"
                      >{{ course.completed_unit_count }}/{{
                        course.unit_count
                      }}
                      Units</span
                    >
                  </div>
                  <div
                    class="w-full h-1.5 bg-untitled-gray-100 rounded-full overflow-hidden"
                  >
                    <div
                      class="h-full bg-app-secondary rounded-full"
                      :style="{
                        width:
                          (course.unit_count
                            ? (course.completed_unit_count /
                                course.unit_count) *
                              100
                            : 0) + '%',
                      }"
                    ></div>
                  </div>
                </div>

                <div class="mt-auto pt-3 border-t border-untitled-gray-100">
                  <button
                    @click="goToCourse(course.unit?.id)"
                    type="button"
                    class="inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-semibold rounded-md text-white bg-app-primary hover:bg-app-secondary transition-colors"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke-width="1.5"
                      stroke="currentColor"
                      class="w-3 h-3"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25"
                      />
                    </svg>
                    Continue Course
                  </button>
                </div>
              </div>
            </li>
          </ul>
          <div
            v-else
            class="flex flex-col items-center justify-center py-12 text-untitled-gray-400"
          >
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="1.5"
              class="w-10 h-10"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
            <p class="mt-3 text-sm font-medium text-untitled-gray-500">
              No courses in progress yet.
            </p>
          </div>
        </div>
      </div>
    </template>
  </GlobalDialog>
</template>

<script setup>
import {
  ref,
  computed,
  defineEmits,
  inject,
  watch,
  defineProps,
  onMounted,
} from "vue";
import { useRouter } from "vue-router";
import LoadingState from "@/components/partials/LoadingState.vue";
import Bugsnag from "@bugsnag/js";
import ECombobox from "@/components/element-components/ECombobox";
import GlobalDialog from "@/components/layout/GlobalDialog.vue";

const courseList = ref([]);
const props = defineProps({
  modelValue: {
    type: Boolean,
    required: true,
    default: false,
  },
});
const emit = defineEmits(["sortBy", "update:modelValue"]);
const router = useRouter();
const axios = inject("axios");
const loading = ref(false);
const showDialog = computed({
  get() {
    return props.modelValue;
  },
  set(newValue) {
    emit("update:modelValue", newValue);
  },
});

const sortBy = ref(null);
const sorts = ref([
  {
    name: "A-Z",
    value: "a-z",
  },
  {
    name: "Z-A",
    value: "z-a",
  },
  {
    name: "Highest to Lowest",
    value: "htl",
  },
  {
    name: "Lowest to Highest",
    value: "lth",
  },
]);

watch(sortBy, (val) => {
  changeSort(val);
});

function changeSort(sortBy) {
  filteredCourseList.value.sort((a, b) => {
    switch (sortBy) {
      case "a-z":
        return a.name.localeCompare(b.name);
      case "z-a":
        return b.name.localeCompare(a.name);
      case "htl":
        return b.completed_unit_count - a.completed_unit_count;
      case "lth":
        return a.completed_unit_count - b.completed_unit_count;
    }
  });
}

function goToCourse(unitId) {
  router.push(`/units/${unitId}`);
}

const filteredCourseList = computed(() => {
  return courseList.value.filter((course) => {
    return course.progress_decimal > 0;
  });
});

const fetchInprogressCourses = async () => {
  loading.value = true;
  await axios
    .get("/api/v3/user/my-progress/courses-in-progress")
    .then((response) => {
      courseList.value = response.data;
      loading.value = false;
    })
    .catch((error) => {
      Bugsnag.notify(error);
      loading.value = false;
    });
};

onMounted(() => {
  fetchInprogressCourses();
});

watch(showDialog, (value) => {
  if (value) {
    fetchInprogressCourses();
  }
});
</script>
